/**
 *observedElements, hiddenElements - refs
 **/
export default function(observedElements, hiddenElements, rootRefName) {
  return {
    methods: {
      getElementsObserver() {
        return new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              let innerText = entry.target.innerText;

              //if tag is on display
              //and if tag is in hiddenTags array already
              //then remove it from hiddenTags
              if (entry.isIntersecting) {
                this[hiddenElements] = this[hiddenElements].filter(
                  ref => ref !== innerText
                );
              } else {
                //if tag is exist in tags array
                //and if it isn't hidden yet
                //then push it into hiddenTags
                if (
                  !this[hiddenElements].includes(innerText) &&
                  this[observedElements].includes(innerText)
                ) {
                  this[hiddenElements].push(innerText);
                }
              }
            });
          },
          {
            //parent observed container
            root: rootRefName ? this.$refs[rootRefName] : null,
            //start trigger callback even if
            //child is hidden in part
            threshold: 1.0
          }
        );
      },

      launchElementsObserver(refs) {
        if (refs.length) {
          refs.map(ref => {
            this.$nextTick(function() {
              let htmlElement = this.$refs[ref][0].$el;
              this.getElementsObserver().observe(htmlElement);
            });
          });
        }
      }
    },
    watch: {
      [observedElements]: {
        handler: function(val) {
          if (val && val.length) {
            this.launchElementsObserver(val);
          }
        },
        immediate: true
      }
    }
  };
}
